import { useState } from "react";
import type { StatsPeriod } from "@trackmark/core";
import { endpoints } from "../api.js";
import { useResource } from "../useResource.js";
import { Failed, Loading } from "./Loading.js";
import { Statistics } from "./Statistics.js";

/** Statistics, reading one endpoint. Four measures arrive together because they are one screen. */
export function StatisticsScreen() {
  const [period, setPeriod] = useState<StatsPeriod>("all");
  const stats = useResource(() => endpoints.statistics(period), [period]);

  if (stats.error) return <Failed error={stats.error} retry={stats.reload} />;
  if (stats.loading || !stats.data) return <Loading what="statistics" />;

  return (
    <Statistics
      period={period}
      onPeriod={setPeriod}
      distribution={stats.data.distribution}
      byDecade={stats.data.byDecade}
      byGenre={stats.data.byGenre}
      coverage={stats.data.coverage}
    />
  );
}
